import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, useParams } from 'react-router-dom';
import './index.css';
import Header from './layout/Header';
import Footer from './layout/Footer';
import Pages from './Pages';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './context/GlobalContext';

ReactDOM.render(
  <React.StrictMode>
    <GlobalProvider>
      <Router>
        <Header />
        <Pages />
        <Footer />
      </Router>
    </GlobalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();